export const publicPaths = [
  '/metadata/v1',
  '/carrier/users/signup',
  '/carrier/users/login',
  '/carrier/users/loginVerify',
  '/users/accountAvailability',
  '/users/forgotPassword',
  '/users/confirmSignup',
  'public',
  '/warning',
  '/contact-option',
  '/users/confirmForgotPassword',
]

export const CARRIER_URLS = {
  CarrierHome: '/start',
  Trips: '/trips',
  ContactOption: '/contact-option/:type',
  Load: '/load/:id',
  Urgent: '/urgent',
  TripV2: '/tripV2/:id',
  TripLegs: '/trip-legs',
  TripLeg: '/trip-leg/:id',
  TripLegPublic: '/trip-leg-public/:id',
  TripLegPublicSuccess: '/trip-leg-public/success',
  Invoices: '/invoices',
  Loads: '/loads',
  FavRoutes: '/fav-routes',
  Users: '/users',
}

export const AUTH_URLS = {
  AuthSuccess: '/auth/success',
  ConfirmForgotPassword: '/confirm-forgot-password',
  EmailLogin: '/auth/email',
  EmailPassword: '/auth/email-password',
  EmailSupportAuth: '/auth/support/email',
  ForgotPassword: '/auth/forgot-password',
  ForgotPasswordSuccess: '/auth/forgot-password-success',
  AuthRedirectionWithLoad: '/authentication',
  Otp: '/auth/otp',
  PhoneNumberLogin: '/auth/phone-number',
  PhoneNumberSupportAuth: '/auth/support/phone-number',
}

export const SIGN_UP_URLS = {
  EmailSignUp: '/sign-up/email',
  PhoneNumberSignUp: '/sign-up/phone-number',
  SetPassword: '/sign-up/set-password',
  CountryAgreement: '/sign-up/country-agreement',
  PhoneNumberOtp: '/sign-up/phone-number-otp',
  EmailVerification: '/sign-up/email-verification',
  PhoneNumberSupportSignUp: '/sign-up/support/phone-number',
  EmailSupportSignUp: '/sign-up/support/email',
  InviteLinkRedirection: '/sign-up/country',
}

export const ONBOARDING_URLS = {
  Policies: '/onboarding/policies',
  CompanyInfo: '/onboarding/company',
  CompanyDocuments: '/onboarding/company-documents',
  UserName: '/onboarding/user',
  EmailNewContact: '/onboarding/new-contact/email',
  PhoneNumberNewContact: '/onboarding/new-contact/phone-number',
  SetPasswordNewContact: '/onboarding/new-contact/password',
  EmailVerificationNewContact: '/onboarding/new-contact/email-verification',
}

export const CARRIER_HOME_PAGE = CARRIER_URLS.CarrierHome

const urls = {
  Home: '/',
  Authentication: '/authentication',
  ...AUTH_URLS,
  ...SIGN_UP_URLS,
  ...ONBOARDING_URLS,
  ...CARRIER_URLS,
}

export default urls
